import {Component, OnInit} from '@angular/core';
import {VeiculosService} from "./veiculos.service";
import {VeiculosModel} from "./veiculos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";

declare let swal, $: any;

@Component({
  selector: 'app-veiculos',
  templateUrl: './veiculos.component.html'
})
export class VeiculosComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"marca":"", "modelo":"", "placa":""};

  veiculos: VeiculosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  mascaraPlaca = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    formBuilder: FormBuilder,
    private veiculosService: VeiculosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'veiculos'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      marca: [],
      modelo: [],
      placa: []
    });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(veiculo) {
    let veiculos = this.veiculos;
    let veiculosService = this.veiculosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarVeiculo')+veiculo.modelo,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(veiculos);
        }

        let index = veiculos.indexOf(veiculo);
        veiculos.splice(index, 1);

        veiculosService.apagar(veiculo.id_veiculo)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.veiculos = veiculos;
            },
            err => {
              // Revert the view back to its original state
              veiculos.splice(index, 0, veiculo);
              self.veiculos = veiculos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.marca != ''){
      filtros['marca'] = '**:'+this.filtroPesquisa.marca;
    }

    if(this.filtroPesquisa.modelo != ''){
      filtros['modelo'] = '**:'+this.filtroPesquisa.modelo;
    }

    if(this.filtroPesquisa.placa != ''){
      filtros['placa'] = this.filtroPesquisa.placa;
    }

    this.veiculosService.getPaginacao(pagina,this.itensPorPagina, null, filtros)
      .subscribe(data => {
        this.veiculos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"marca":"", "modelo":"", "placa":""};
  }

  // evento quando a placa é alterada
  changePlaca(e){
    this.filtroPesquisa.placa = e.toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/veiculos/veiculos.component.ts